import { periodsConstants } from '../constants';

const initialState = {
    fetchingPeriods: false,
    periods: null,
    fetchingPeriodsError: null,
    setPeriodsError: null,
    fetchingExpandedPeriods: false,
    fetchingExpandedPeriodsError: null,
    expandedPeriods: null,
    setExpandedPeriodsError: null,
    pollingExpandedPeriods: false,
};

export function periods(state = initialState, action) {
    switch (action.type) {
        case periodsConstants.GET_PERIODS_REQUEST: {
            return {
                ...state,
                fetchingPeriods: true,
                periods: null,
                fetchingPeriodsError: null,
            };
        }
        case periodsConstants.GET_PERIODS_SUCCESS: {
            return {
                ...state,
                fetchingPeriods: false,
                periods: action.periods,
                fetchingPeriodsError: null,
            };
        }
        case periodsConstants.GET_PERIODS_FAILURE: {
            return {
                ...state,
                fetchingPeriods: false,
                fetchingPeriodsError: action.error,
            };
        }

        case periodsConstants.SET_PERIODS_SUCCESS: {
            return {
                ...state,
                settingPeriods: false,
                periods: action.periods,
            };
        }
        case periodsConstants.SET_PERIODS_FAILURE: {
            return {
                ...state,
                settingPeriods: false,
                setPeriodsError: action.error,
            };
        }

        case periodsConstants.GET_EXPANDED_PERIODS_REQUEST: {
            return {
                ...state,
                fetchingExpandedPeriods: true,
                fetchingExpandedPeriodsError: null,
            };
        }
        case periodsConstants.GET_EXPANDED_PERIODS_SUCCESS: {
            return {
                ...state,
                fetchingExpandedPeriods: false,
                expandedPeriods: [...action.expandedPeriods],
            };
        }
        case periodsConstants.GET_EXPANDED_PERIODS_FAILURE: {
            return {
                ...state,
                fetchingExpandedPeriods: false,
                fetchingExpandedPeriodsError: action.error,
            };
        }

        case periodsConstants.SET_EXPANDED_PERIODS_REQUEST: {
            return {
                ...state,
                settingExpandedPeriods: true,
                settingExpandedPeriodsError: null,
            };
        }
        case periodsConstants.SET_EXPANDED_PERIODS_SUCCESS: {
            return {
                ...state,
                settingExpandedPeriods: false,
                expandedPeriods: [...action.expandedPeriods],
            };
        }
        case periodsConstants.SET_EXPANDED_PERIODS_FAILURE: {
            return {
                ...state,
                settingExpandedPeriods: false,
                setExpandedPeriodsError: action.error,
            };
        }
        
        
        default: {
            return state;
        }
    }
}
